import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ExportBy extends Component {
    _renderExportBy = (exportBy) => {
        if (exportBy === 'side') {
            return 'Side'
        } else if (exportBy === 'size') {
            return 'Size'
        }

        return 'None'
    }

    render() {
        const {exportBy} = this.props
        const exportType = this._renderExportBy(exportBy)

        return (
            <td className='ExportBy'>
                {exportType}
            </td>
        )
    }
}

ExportBy.propTypes = {
    exportBy: PropTypes.string
}

export default ExportBy